module.exports = __webpack_public_path__ + "static/media/Message_Inbox_Loyalty_Promo@3x.67a2c678.png";